import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ApiValidationFailure } from '../api/http';
import { ValidationFindingsTable } from './ValidationFindingsTable';

/** What the checks concluded: how it ended for the document, and every finding behind that. */
export interface ValidationFindings {
  /** 'error' when the content was refused, 'warning' when it got in with reservations. */
  severity: 'error' | 'warning';
  message: string;
  items: ApiValidationFailure[];
}

export interface ValidationFindingsDialogProps {
  findings: ValidationFindings;
  onClose: () => void;
}

/**
 * The findings in a dialog of their own: the four-column table needs width, and squeezing it into
 * whatever form happened to trigger the checks made it unreadable.
 */
export function ValidationFindingsDialog({ findings, onClose }: ValidationFindingsDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('files.validation.title')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Alert severity={findings.severity}>{findings.message}</Alert>
          <ValidationFindingsTable findings={findings.items} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('actions.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
